<template lang="pug">
app-page-layout(fix-header)
  div.full-container 
    div.projects
      ProjectList(v-model="project" @change="handleProjectChange")
    div.main
      div.main-header
        div.title {{project?project.name:'请选择项目'}}
      div.main-body(v-if="project")
        a-tabs.full-height(default-active-key="1")
          a-tab-pane(key="1" tab="PC")
            div.tab-panel-container
              ResourceTable(v-model="pc_resources")
          a-tab-pane(key="2" tab="APP")
            div.tab-panel-container
              AppResourceTable(v-model="app_resources")        
      div.main-footer(v-if="project")       
        a-button(type="primary" @click="handleSave" :loading="loading" :disabled="!project || roleLoading") 保存
</template>

<script>
import ProjectList from './ProjectList';
import ResourceTable from './ResourceTable';
import AppResourceTable from './AppResourceTable';
export default {
  components: {
    ProjectList,
    ResourceTable,
    AppResourceTable,
  },
  data() {
    return {
      project: null,
      pc_resources: [],
      app_resources: [],
      loading: false,
      roleLoading: false,
    };
  },
  methods: {
    handleProjectChange() {
      this.roleLoading = true;
      this.$restful(`GET:/sys/projects/${this.project.id}/resources`)
        .then((res) => {
          this.pc_resources = res['web-site'];
          this.app_resources = res['web-app'];
        })
        .finally(() => {
          this.roleLoading = false;
        });
    },
    handleSave() {
      this.loading = true;
      const resources = this.pc_resources.concat(this.app_resources);
      this.$restful(`POST:/sys/projects/${this.project.id}/resources`, {
        resourceIds: [...new Set(resources)],
      })
        .then(() => {
          this.$message.success('保存成功!');
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.full-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  .projects {
    width: 240px;
    border-right: 1px solid #f0f0f0;
  }
  .main {
    width: calc(100% - 240px);
    padding: 20px;
    .main-header {
      // background-color: #fafafa;
      padding: 0 1rem;
      .title {
        font-size: 2em;
        color: rgba(0, 0, 0, 0.85);
        padding: 1rem 0;
      }
    }
    .main-body {
      max-height: calc(100% - 100px);
      .full-height {
        height: 100%;
        .tab-panel-container {
          max-height: calc(100vh - 330px);
          overflow: auto;
        }
      }
    }
    .main-footer {
      padding: 1rem 0;
      position: sticky;
      bottom: 0;
      background-color: #fff;
    }
  }
}
</style>
